import {
  RESPONSE_CHOOSE_CAR,
  CLEAR_CHOOSE_CAR,
} from '../actions/choosedCarActions'

const initialState = {
  data: {},
}

const choosedCarReducer = (state = initialState, action) => {
  switch (action.type) {
    case RESPONSE_CHOOSE_CAR: {
      return Object.assign(
        {},
        state,
        {
          data: action.data
        }
      )
    }
    case CLEAR_CHOOSE_CAR: {
      return Object.assign(
        {},
        state,
        {
          data: {},
        }
      )
    }
    default:
      return state
  }
}

export default choosedCarReducer
